<template>
  <el-cascader v-if="value" v-model="region" @change="handleChanges" :props="area" ></el-cascader>
</template>
<script>
import User from "@/api/user";
export default {
  props: {
    value: String,
  },
  data() {
    let that = this;
    return {
      area: {
        lazy: true,
        index: this.index,
        lazyLoad: (node, resolve) => {
          setTimeout(() => {
            that.region = that.value.split('/')
            if (node.level == 0) {
                  User.getProvince({}).then((res) => {
                    let data = res.data.map((item) => {
                        return {
                          value: item.provinceName,
                          label: item.provinceName,
                          code: item.provinceCode,
                          disabled: that.region[0] == item.provinceName ? false: true,
                        }
                    });
                    resolve(data);
                  });              
              }
            if (node.level == 1) {
              User.getCity({ provinceCode:node.data.code  }).then((res) => {
                let data = res.data.map((item) => {
                  return {
                    value: item.cityName,
                    label: item.cityName,
                    code: item.cityCode,
                    disabled: that.region[1] == item.cityName ? false: true,
                  };
                });
                resolve(data);
              });
            }
            if (node.level == 2) {
              User.getArea({ cityCode: node.data.code })
                .then((res) => {
                  let data = res.data.map((item) => {
                    return {
                      value: item.areaName,
                      label: item.areaName,
                      code: item.areaCode,
                      leaf: false,
                      disabled: that.region[2] ? (that.region[2] == item.areaName ? false: true) : false,
                    };
                  });
                  this.list = res.data.map((item) => {
                    return {
                      name: item.areaName,
                      id: item.areaConfigId
                    }
                  })
                  resolve(data);
                }).catch((err) => console.log(err));
            }
            if (node.level == 3) {
                User.getStreet({ areaCode: node.data.code }).then((res) => {
                  let data = res.data.map((item) => {
                    return {
                      value: item.streetName,
                      label: item.streetName,
                      code: item.streetCode,
                      leaf: true,
                      disabled: false
                    };
                  });
                  resolve(data);
                }).catch((err) => console.log(err));
            }
          }, 100);
        },
      },
      region: null,
      list: []
    };
  },
  watch: {
    value(newVal, oldVal){
      if(newVal){
        this.region = this.value.split("/")
      }
    }
  },
  async created () {},
  methods: {
    handleChanges(value) {
      let id = ''
      this.list.map(item => {
        if (item.name === value[2]) {
          id = item.id
        }
      })
      let area = value.join("/");
      this.$emit("input", area);
      this.$emit("areaId", id)
    },
  },
};
</script>
<style lang="scss">
.el-cascader__dropdown {
  .el-cascader-node.is-disabled.in-active-path,
  .el-cascader-node.is-disabled.is-active {
    color: #f65248 !important;
  }
}
</style>